// KIND WORK 패치본 — 업스트림 app/javascript/template_builder/i18n.js 전체(en~nl)는
// 그대로 두고 ko/ja/zh-CN/zh-TW 블록을 추가했다. export 이름에 하이픈이 들어간 두 항목은
// ES2022 arbitrary module namespace export 문법(`export { x as 'zh-cn' }`)을 쓴다 —
// builder.vue 가 `import * as i18n from './i18n'` 후 `i18n[this.language]`(소문자+하이픈
// 문자열)로 조회하기 때문이다. 실제 빌드(Shakapacker/webpack)가 이 구문을 지원하는지
// 빌드 로그로 반드시 확인할 것 — 실패하면 이 파일을 submission_form-i18n.js 처럼 단일
// default export 객체로 바꾸고 builder.vue의 import 문도 함께 고쳐야 한다.
// 생성: infra/groupware/docuseal-l10n 작업(2026-09-26). 원본 기준 커밋:
// 8c4cbd86f7186765c0975094af717e93138613ac

const en = {
  fixed: 'Fixed',
  default: 'Default',
  save_as_custom_field: 'Save as custom field',
  kba: 'KBA',
  analyzing_: 'Analyzing...',
  download: 'Download',
  downloading_: 'Downloading...',
  view: 'View',
  autodetect_fields: 'Autodetect Fields',
  payment_link: 'Payment link',
  strikeout: 'Strikeout',
  draw_strikethrough_the_document: 'Draw strikethrough the document',
  quantity: 'Quantity',
  prefillable: 'Prefillable',
  signature_id: 'Signature ID',
  error_message: 'Error message',
  length: 'Length',
  min: 'Min',
  max: 'Max',
  font: 'Font',
  party: 'Party',
  date_signed: 'Date Signed',
  method: 'Method',
  reorder_fields: 'Reorder fields',
  verify_id: 'Verify ID',
  obtain_qualified_electronic_signature_with_the_trusted_provider_click_to_learn_more: 'Obtain qualified electronic signature (QeS) with the trusted provider. Click to learn more.',
  editable: 'Editable',
  recurrent: 'Recurrent',
  one_off: 'One-off',
  search_field: 'Search field',
  field_not_found: 'Field not found',
  clear: 'Clear',
  align: 'Align',
  resize: 'Resize',
  width: 'Width',
  height: 'Height',
  add_all_required_fields_to_continue: 'Add all required fields to continue',
  uploaded_pdf_contains_form_fields_keep_or_remove_them: 'Uploaded PDF contains form fields. Keep or remove them?',
  keep: 'Keep',
  left: 'Left',
  heading: 'Heading',
  validation: 'Validation',
  add_blank_page: 'Add blank page',
  right: 'Right',
  center: 'Center',
  description: 'Description',
  display_title: 'Display title',
  with_logo: 'With logo',
  unchecked: 'Unchecked',
  price: 'Price',
  type: 'Type',
  list: 'list',
  no_variables: 'No variables yet',
  no_variables_description: 'Add [[variable]] marks to your document to create dynamic content variables.',
  type_value: 'Type value',
  equal: 'Equal',
  not_equal: 'Not equal',
  greater_than: 'Greater than',
  less_than: 'Less than',
  contains: 'Contains',
  does_not_contain: 'Does not contain',
  not_empty: 'Not empty',
  empty: 'Empty',
  select_field_: 'Select field...',
  select_value_: 'Select value...',
  remove_condition: 'Remove condition',
  add_condition: 'Add condition',
  are_you_sure_: 'Are you sure?',
  sign_yourself: 'Sign Yourself',
  set_signing_date: 'Set signing date',
  signing_date: 'Signing Date',
  send: 'Send',
  remove: 'Remove',
  edit: 'Edit',
  settings: 'Settings',
  up: 'Up',
  down: 'Down',
  checked: 'Checked',
  current_date: 'Current date',
  save: 'Save',
  cancel: 'Cancel',
  any: 'Any',
  drawn: 'Drawn',
  drawn_or_typed: 'Drawn or Typed',
  drawn_or_upload: 'Drawn or Upload',
  upload: 'Upload',
  formula: 'Formula',
  typed: 'Typed',
  draw_field_on_the_document: 'Draw a field on the document',
  click_to_upload: 'Click to upload',
  or_drag_and_drop_files: 'or drag and drop files',
  uploading: 'Uploading',
  processing_: 'Processing...',
  add_pdf_documents_or_images: 'Add PDF documents or images',
  add_documents_or_images: 'Add documents or images',
  add_a_new_document: 'Add a new document',
  replace_existing_document: 'Replace existing document',
  clone_and_replace_documents: 'Clone and replace documents',
  required: 'Required',
  default_value: 'Default value',
  format: 'Format',
  read_only: 'Read-only',
  page: 'Page',
  draw_new_area: 'Draw new area',
  copy_to_all_pages: 'Copy to all pages',
  more: 'More',
  add_option: 'Add option',
  option: 'Option',
  options: 'Options',
  condition: 'Condition',
  make_dynamic: 'Make dynamic',
  first_party: 'First Party',
  second_party: 'Second Party',
  third_party: 'Third Party',
  fourth_party: 'Fourth Party',
  fifth_party: 'Fifth Party',
  sixth_party: 'Sixth Party',
  seventh_party: 'Seventh Party',
  eighth_party: 'Eighth Party',
  ninth_party: 'Ninth Party',
  tenth_party: 'Tenth Party',
  eleventh_party: 'Eleventh Party',
  twelfth_party: 'Twelfth Party',
  thirteenth_party: 'Thirteenth Party',
  fourteenth_party: 'Fourteenth Party',
  fifteenth_party: 'Fifteenth Party',
  sixteenth_party: 'Sixteenth Party',
  seventeenth_party: 'Seventeenth Party',
  eighteenth_party: 'Eighteenth Party',
  nineteenth_party: 'Nineteenth Party',
  twentieth_party: 'Twentieth Party',
  draw: 'Draw',
  add: 'Add',
  or_add_field_without_drawing: 'Or add field without drawing',
  text: 'Text',
  number: 'Number',
  signature: 'Signature',
  initials: 'Initials',
  date: 'Date',
  image: 'Image',
  file: 'File',
  select: 'Select',
  checkbox: 'Checkbox',
  multiple: 'Multiple',
  radio: 'Radio',
  cells: 'Cells',
  stamp: 'Stamp',
  payment: 'Payment',
  phone: 'Phone',
  text_field: 'Text Field',
  signature_field: 'Signature Field',
  initials_field: 'Initials Field',
  date_field: 'Date Field',
  number_field: 'Number Field',
  image_field: 'Image Field',
  file_field: 'File Field',
  select_field: 'Select Field',
  checkbox_field: 'Checkbox Field',
  multiple_field: 'Multiple Select Field',
  radio_field: 'Radio Group Field',
  cells_field: 'Cells Field',
  stamp_field: 'Stamp Field',
  payment_field: 'Payment Field',
  phone_field: 'Phone Field',
  draw_a_text_field_on_the_page_with_a_mouse: 'Draw a text field on the page with a mouse',
  drag_and_drop_any_other_field_type_on_the_page: 'Drag & drop any other field type on the page',
  click_on_the_field_type_above_to_start_drawing_it: 'Click on the field type above to start drawing it',
  please_draw_fields_to_prepare_the_document: 'Please draw fields to prepare the document.',
  only_pdf_and_images_are_supported: 'Only PDF and images are supported.',
  unlock_sms_verified_phone_number_field_with_paid_plan_use_text_field_for_phone_numbers_without_verification: 'Unlock SMS-verified phone number field with paid plan. Use text field for phone numbers without verification.',
  available_only_in_pro: 'Available only in Pro',
  failed_to_download_files: 'Failed to download files',
  please_add_fields_for_the_submitter_name_or_remove_the_submitter_name_if_not_needed: 'Please add fields for the {submitter_name}. Or, remove the {submitter_name} if not needed.',
  draw_field: 'Draw {field} Field',
  replace: 'Replace',
  uploading_: 'Uploading...',
  add_document: 'Add Document',
  none: 'None',
  ssn: 'SSN',
  ein: 'EIN',
  email: 'Email',
  url: 'URL',
  zip: 'ZIP',
  custom: 'Custom',
  numbers_only: 'Numbers only',
  letters_only: 'Letters only',
  regexp_validation: 'Regexp validation',
  custom_validation: 'Custom Validation',
  length_validation: 'Length Validation',
  number_range: 'Number Range',
  enter_pdf_password: 'Enter PDF password',
  wrong_password: 'Wrong password',
  currency: 'Currency',
  save_and_preview: 'Save and Preview',
  preferences: 'Preferences',
  available_in_pro: 'Available in Pro',
  some_fields_are_missing_in_the_formula: 'Some fields are missing in the formula.',
  learn_more: 'Learn more',
  and: 'and',
  or: 'or',
  start_a_quick_tour_to_learn_how_to_create_an_send_your_first_document: 'Start a quick tour to learn how to create and send your first document',
  start_tour: 'Start Tour',
  or_add_from: 'Or add from',
  sync: 'Sync',
  syncing: 'Syncing...',
  copy: 'Copy',
  paste: 'Paste',
  select_fields: 'Select Fields',
  draw_fields: 'Draw Fields',
  align_left: 'Align Left',
  align_right: 'Align Right',
  align_top: 'Align Top',
  align_bottom: 'Align Bottom',
  fields_selected: '{count} Fields Selected',
  field_added: '{count} Field Added',
  fields_added: '{count} Fields Added'
}

const es = {
  fixed: 'Fijo',
  default: 'Predeterminado',
  save_as_custom_field: 'Guardar como personalizado',
  kba: 'KBA',
  autodetect_fields: 'Autodetectar campos',
  analyzing_: 'Analizando...',
  download: 'Descargar',
  downloading_: 'Descargando...',
  view: 'Vista',
  payment_link: 'Enlace de pago',
  strikeout: 'Tachar',
  draw_strikethrough_the_document: 'Dibujar una línea de tachado en el documento',
  quantity: 'Cantidad',
  prefillable: 'Rellenable',
  signature_id: 'ID de Firma',
  error_message: 'Mensaje de error',
  length: 'Longitud',
  min: 'Mín',
  max: 'Máx',
  date_signed: 'Fecha actual',
  fuente: 'Fuente',
  party: 'Parte',
  method: 'Método',
  reorder_fields: 'Reordenar campos',
  verify_id: 'Verificar ID',
  obtain_qualified_electronic_signature_with_the_trusted_provider_click_to_learn_more: 'Obtenga una firma electrónica cualificada (QeS) con el proveedor de confianza. Haga clic para obtener más información.',
  recurrent: 'Recurrente',
  one_off: 'Único',
  editable: 'Editable',
  search_field: 'Campo de búsqueda',
  field_not_found: 'Campo no encontrado',
  clear: 'Borrar',
  type: 'Tipo',
  list: 'lista',
  no_variables: 'Aún sin variables',
  no_variables_description: 'Agregue marcas [[variable]] a su documento para crear variables de contenido dinámico.',
  type_value: 'Escriba valor',
  align: 'Alinear',
  resize: 'Redimensionar',
  width: 'Ancho',
  height: 'Alto',
  add_all_required_fields_to_continue: 'Agregar todos los campos requeridos para continuar',
  uploaded_pdf_contains_form_fields_keep_or_remove_them: 'El PDF cargado tiene campos. ¿Mantenerlos o eliminarlos?',
  keep: 'Mantener',
  left: 'Izquierda',
  heading: 'Encabezado',
  validation: 'Validación',
  add_blank_page: 'Agregar página en blanco',
  right: 'Derecha',
  center: 'Centro',
  with_logo: 'Con logotipo',
  description: 'Descripción',
  signing_date: 'Fecha de Firma',
  display_title: 'Título de visualización',
  unchecked: 'No marcado',
  price: 'Precio',
  equal: 'Igual',
  not_equal: 'No es igual',
  greater_than: 'Mayor que',
  less_than: 'Menor que',
  contains: 'Contiene',
  does_not_contain: 'No contiene',
  not_empty: 'No vacío',
  empty: 'Vacío',
  select_field_: 'Seleccionar campo...',
  select_value_: 'Seleccionar valor...',
  remove_condition: 'Eliminar condición',
  add_condition: 'Agregar condición',
  condition: 'Condición',
  make_dynamic: 'Hacer dinámico',
  formula: 'Fórmula',
  edit: 'Editar',
  settings: 'Configuración',
  up: 'Arriba',
  down: 'Abajo',
  set_signing_date: 'Establecer fecha de firma',
  are_you_sure_: '¿Estás seguro?',
  sign_yourself: 'Firma tú mismo',
  checked: 'Seleccionado',
  current_date: 'Fecha actual',
  send: 'Enviar',
  remove: 'Eliminar',
  save: 'Guardar',
  cancel: 'Cancelar',
  or_add_field_without_drawing: 'O añadir campo sin dibujar',
  draw_field_on_the_document: 'Dibujar un campo en el documento',
  click_to_upload: 'Haz clic para cargar',
  or_drag_and_drop_files: 'o arrastra y suelta archivos',
  uploading: 'Subiendo',
  processing_: 'Procesando...',
  add_pdf_documents_or_images: 'Agregar documentos PDF o imágenes',
  add_documents_or_images: 'Agregar documentos o imágenes',
  add_a_new_document: 'Agregar un nuevo documento',
  replace_existing_document: 'Reemplazar documento existente',
  clone_and_replace_documents: 'Clonar y reemplazar documentos',
  required: 'Requerido',
  default_value: 'Valor predeterminado',
  format: 'Formato',
  read_only: 'Solo lectura',
  page: 'Página',
  draw_new_area: 'Dibujar nueva área',
  copy_to_all_pages: 'Copiar a todas las páginas',
  more: 'Más',
  add_option: 'Agregar opción',
  option: 'Opción',
  options: 'Opciones',
  first_party: 'Primera Parte',
  second_party: 'Segunda Parte',
  third_party: 'Tercera Parte',
  fourth_party: 'Cuarta Parte',
  fifth_party: 'Quinta Parte',
  sixth_party: 'Sexta Parte',
  seventh_party: 'Séptima Parte',
  eighth_party: 'Octava Parte',
  ninth_party: 'Novena Parte',
  tenth_party: 'Décima Parte',
  eleventh_party: 'Undécimo Partido',
  twelfth_party: 'Duodécimo Partido',
  thirteenth_party: 'Decimotercer Partido',
  fourteenth_party: 'Catorceavo Partido',
  fifteenth_party: 'Quinceavo Partido',
  sixteenth_party: 'Dieciséisavo Partido',
  seventeenth_party: 'Diecisieteavo Partido',
  eighteenth_party: 'Dieciochoavo Partido',
  nineteenth_party: 'Decimonovena Fiesta',
  twentieth_party: 'Vigésima Fiesta',
  draw: 'Dibujar',
  add: 'Agregar',
  text: 'Texto',
  signature: 'Firma',
  initials: 'Iniciales',
  date: 'Fecha',
  number: 'Número',
  image: 'Imagen',
  file: 'Archivo',
  select: 'Seleccionar',
  checkbox: 'Casilla',
  multiple: 'Múltiple',
  radio: 'Radio',
  cells: 'Celdas',
  stamp: 'Sello',
  payment: 'Pago',
  phone: 'Teléfono',
  text_field: 'Campo de Texto',
  signature_field: 'Campo de Firma',
  initials_field: 'Campo de Iniciales',
  date_field: 'Campo de Fecha',
  number_field: 'Campo de Número',
  image_field: 'Campo de Imagen',
  file_field: 'Campo de Archivo',
  select_field: 'Campo de Selección',
  checkbox_field: 'Campo de Casilla',
  multiple_field: 'Campo Múltiple',
  radio_field: 'Campo de Grupo Radio',
  cells_field: 'Campo de Celdas',
  stamp_field: 'Campo de Sello',
  payment_field: 'Campo de Pago',
  phone_field: 'Campo de Teléfono',
  draw_a_text_field_on_the_page_with_a_mouse: 'Dibujar un campo de texto en la página con el mouse',
  drag_and_drop_any_other_field_type_on_the_page: 'Arrastra y suelta cualquier otro tipo de campo en la página',
  click_on_the_field_type_above_to_start_drawing_it: 'Haz clic en el tipo de campo de arriba para comenzar a dibujarlo',
  please_draw_fields_to_prepare_the_document: 'Por favor, dibuja los campos para preparar el documento.',
  only_pdf_and_images_are_supported: 'Solo se admiten PDF e imágenes.',
  unlock_sms_verified_phone_number_field_with_paid_plan_use_text_field_for_phone_numbers_without_verification: 'Desbloquea el campo de número de teléfono verificado por SMS con un plan pago. Usa el campo de texto para números de teléfono sin verificación.',
  available_only_in_pro: 'Disponible solo en Pro',
  failed_to_download_files: 'Error al descargar los archivos',
  please_add_fields_for_the_submitter_name_or_remove_the_submitter_name_if_not_needed: 'Por favor, añade campos para {submitter_name} o elimina {submitter_name} si no es necesario.',
  draw_field: 'Dibujar campo {field}',
  replace: 'Reemplazar',
  uploading_: 'Subiendo...',
  add_document: 'Subir',
  any: 'Cualquier',
  drawn: 'Dibujado',
  drawn_or_typed: 'Dibujado o Escrito',
  drawn_or_upload: 'Dibujado o Subido',
  upload: 'Subir',
  typed: 'Escrito',
  none: 'Ninguno',
  ssn: 'SSN',
  ein: 'EIN',
  email: 'Correo electrónico',
  url: 'URL',
  zip: 'ZIP',
  custom: 'Personalizado',
  numbers_only: 'Solo números',
  letters_only: 'Solo letras',
  regexp_validation: 'Validación de expresión regular',
  custom_validation: 'Validación Personalizada',
  length_validation: 'Validación de Longitud',
  number_range: 'Rango de Números',
  enter_pdf_password: 'Ingrese la contraseña del PDF',
  wrong_password: 'Contraseña incorrecta',
  currency: 'Moneda',
  save_and_preview: 'Guardar y previsualizar',
  preferences: 'Preferencias',
  available_in_pro: 'Disponible en Pro',
  some_fields_are_missing_in_the_formula: 'Faltan algunos campos en la fórmula.',
  learn_more: 'Aprende más',
  and: 'y',
  or: 'o',
  start_a_quick_tour_to_learn_how_to_create_an_send_your_first_document: 'Inicia una guía rápida para aprender a crear y enviar tu primer documento.',
  start_tour: 'Iniciar guía',
  or_add_from: 'O agregar desde',
  sync: 'Sincronizar',
  syncing: 'Sincronizando...',
  copy: 'Copiar',
  paste: 'Pegar',
  select_fields: 'Seleccionar Campos',
  draw_fields: 'Dibujar Campos',
  align_left: 'Alinear a la izquierda',
  align_right: 'Alinear a la derecha',
  align_top: 'Alinear arriba',
  align_bottom: 'Alinear abajo',
  fields_selected: '{count} Campos Seleccionados',
  field_added: '{count} Campo Añadido',
  fields_added: '{count} Campos Añadidos'
}

const it = {
  fixed: 'Fisso',
  default: 'Predefinito',
  save_as_custom_field: 'Salva come personalizzato',
  kba: 'KBA',
  autodetect_fields: 'Rileva campi',
  analyzing_: 'Analisi...',
  download: 'Scarica',
  downloading_: 'Download in corso...',
  view: 'Vista',
  payment_link: 'Link di pagamento',
  strikeout: 'Barrato',
  draw_strikethrough_the_document: 'Disegna una linea barrata sul documento',
  quantity: 'Quantità',
  prefillable: 'Precompilabile',
  signature_id: 'ID firma',
  error_message: 'Messaggio di errore',
  length: 'Lunghezza',
  min: 'Min',
  max: 'Max',
  date_signed: 'Data attuale',
  font: 'Carattere',
  party: 'Parte',
  method: 'Metodo',
  reorder_fields: 'Riordina i campi',
  verify_id: 'Verifica ID',
  obtain_qualified_electronic_signature_with_the_trusted_provider_click_to_learn_more: 'Ottieni una firma elettronica qualificata (QeS) con il fornitore di fiducia. Clicca per saperne di più.',
  ricorrente: 'Ricorrente',
  una_volta: 'Una volta',
  editable: 'Modificabile',
  search_field: 'Campo di ricerca',
  field_not_found: 'Campo non trovato',
  clear: 'Cancella',
  align: 'Allinea',
  resize: 'Ridimensiona',
  width: 'Larghezza',
  height: 'Altezza',
  add_all_required_fields_to_continue: 'Aggiungi tutti i campi obbligatori per continuare',
  uploaded_pdf_contains_form_fields_keep_or_remove_them: 'Il PDF caricato contiene campi del modulo. Mantenerli o rimuoverli?',
  keep: 'Mantieni',
  left: 'Sinistra',
  heading: 'Intestazione',
  validation: 'Validazione',
  add_blank_page: 'Aggiungi pagina vuota',
  right: 'Destra',
  center: 'Centro',
  description: 'Descrizione',
  display_title: 'Mostra titolo',
  with_logo: 'Con logo',
  unchecked: 'Non selezionato',
  price: 'Prezzo',
  type: 'Tipo',
  list: 'lista',
  no_variables: 'Ancora nessuna variabile',
  no_variables_description: 'Aggiungi marcatori [[variable]] al documento per creare variabili di contenuto dinamico.',
  type_value: 'Inserisci valore',
  equal: 'Uguale',
  not_equal: 'Non uguale',
  greater_than: 'Maggiore di',
  less_than: 'Minore di',
  contains: 'Contiene',
  does_not_contain: 'Non contiene',
  not_empty: 'Non vuoto',
  empty: 'Vuoto',
  select_field_: 'Seleziona campo...',
  select_value_: 'Seleziona valore...',
  remove_condition: 'Rimuovi condizione',
  add_condition: 'Aggiungi condizione',
  are_you_sure_: 'Sei sicuro?',
  sign_yourself: 'Firma te stesso',
  set_signing_date: 'Imposta data di firma',
  signing_date: 'Data di firma',
  send: 'Invia',
  remove: 'Rimuovi',
  edit: 'Modifica',
  settings: 'Impostazioni',
  up: 'Su',
  down: 'Giù',
  checked: 'Selezionato',
  current_date: 'Data corrente',
  save: 'Salva',
  cancel: 'Annulla',
  any: 'Qualsiasi',
  drawn: 'Disegnato',
  drawn_or_typed: 'Disegnato o Digitato',
  drawn_or_upload: 'Disegnato o Caricato',
  upload: 'Caricare',
  formula: 'Formula',
  typed: 'Digitato',
  draw_field_on_the_document: 'Disegnare un campo sul documento',
  click_to_upload: 'Clicca per caricare',
  or_drag_and_drop_files: 'o trascina e rilascia i file',
  uploading: 'Caricamento in corso',
  processing_: 'Elaborazione...',
  add_pdf_documents_or_images: 'Aggiungi documenti PDF o immagini',
  add_documents_or_images: 'Aggiungi documenti o immagini',
  add_a_new_document: 'Aggiungi un nuovo documento',
  replace_existing_document: 'Sostituisci documento esistente',
  clone_and_replace_documents: 'Clona e sostituisci documenti',
  required: 'Obbligatorio',
  default_value: 'Valore predefinito',
  format: 'Formato',
  read_only: 'Sola lettura',
  page: 'Pagina',
  draw_new_area: 'Disegna nuova area',
  copy_to_all_pages: 'Copia in tutte le pagine',
  more: 'Altro',
  add_option: 'Aggiungi opzione',
  option: 'Opzione',
  options: 'Opzioni',
  condition: 'Condizione',
  make_dynamic: 'Rendi dinamico',
  first_party: 'Prima parte',
  second_party: 'Seconda parte',
  third_party: 'Terza parte',
  fourth_party: 'Quarta parte',
  fifth_party: 'Quinta parte',
  sixth_party: 'Sesta parte',
  seventh_party: 'Settima parte',
  eighth_party: 'Ottava parte',
  ninth_party: 'Nona parte',
  tenth_party: 'Decima parte',
  eleventh_party: 'Undicesima parte',
  twelfth_party: 'Dodicesima parte',
  thirteenth_party: 'Tredicesima parte',
  fourteenth_party: 'Quattordicesima parte',
  fifteenth_party: 'Quindicesima parte',
  sixteenth_party: 'Sedicesima parte',
  seventeenth_party: 'Diciassettesima parte',
  eighteenth_party: 'Diciottesima parte',
  nineteenth_party: 'Diciannovesima parte',
  twentieth_party: 'Ventesima parte',
  draw: 'Disegna',
  add: 'Aggiungi',
  or_add_field_without_drawing: 'Oppure aggiungi campo senza disegno',
  text: 'Testo',
  number: 'Numero',
  signature: 'Firma',
  initials: 'Iniziali',
  date: 'Data',
  image: 'Immagine',
  file: 'File',
  select: 'Seleziona',
  checkbox: 'Checkbox',
  multiple: 'Multiplo',
  radio: 'Radio',
  cells: 'Celle',
  stamp: 'Timbro',
  payment: 'Pagamento',
  phone: 'Telefono',
  text_field: 'Campo di Testo',
  signature_field: 'Campo di Firma',
  initials_field: 'Campo di Iniziali',
  date_field: 'Campo Data',
  number_field: 'Campo Numero',
  image_field: 'Campo Immagine',
  file_field: 'Campo File',
  select_field: 'Campo di Selezione',
  checkbox_field: 'Campo di Checkbox',
  multiple_field: 'Campo Selezione Multipla',
  radio_field: 'Campo di Gruppo Radio',
  cells_field: 'Campo Celle',
  stamp_field: 'Campo Timbro',
  payment_field: 'Campo Pagamento',
  phone_field: 'Campo Telefono',
  draw_a_text_field_on_the_page_with_a_mouse: 'Disegna un campo di testo sulla pagina con il mouse',
  drag_and_drop_any_other_field_type_on_the_page: 'Trascina e rilascia qualsiasi altro tipo di campo sulla pagina',
  click_on_the_field_type_above_to_start_drawing_it: 'Clicca sul tipo di campo sopra per iniziare a disegnarlo',
  please_draw_fields_to_prepare_the_document: 'Per favore, disegna i campi per preparare il documento.',
  only_pdf_and_images_are_supported: 'Sono supportati solo PDF e immagini.',
  unlock_sms_verified_phone_number_field_with_paid_plan_use_text_field_for_phone_numbers_without_verification: 'Sblocca il campo numero di telefono verificato tramite SMS con un piano a pagamento. Usa il campo di testo per numeri di telefono senza verifica.',
  available_only_in_pro: 'Disponibile solo in Pro',
  failed_to_download_files: 'Impossibile scaricare i file',
  please_add_fields_for_the_submitter_name_or_remove_the_submitter_name_if_not_needed: 'Aggiungi campi per {submitter_name} o rimuovi {submitter_name} se non necessario.',
  draw_field: 'Disegna il campo {field}',
  replace: 'Sostituisci',
  uploading_: 'Caricamento in corso...',
  add_document: 'Aggiungi',
  none: 'Nessuno',
  ssn: 'SSN',
  ein: 'EIN',
  email: 'Email',
  url: 'URL',
  zip: 'CAP',
  custom: 'Personalizzato',
  numbers_only: 'Solo numeri',
  letters_only: 'Solo lettere',
  regexp_validation: 'Validazione regexp',
  custom_validation: 'Validazione Personalizzata',
  length_validation: 'Validazione Lunghezza',
  number_range: 'Intervallo Numerico',
  enter_pdf_password: 'Inserisci password PDF',
  wrong_password: 'Password errata',
  currency: 'Valuta',
  save_and_preview: 'Salva e Anteprima',
  preferences: 'Preferenze',
  available_in_pro: 'Disponibile in Pro',
  some_fields_are_missing_in_the_formula: 'Alcuni campi mancano nella formula.',
  learn_more: 'Scopri di più',
  and: 'e',
  or: 'o',
  start_a_quick_tour_to_learn_how_to_create_an_send_your_first_document: 'Inizia un tour rapido per imparare a creare e inviare il tuo primo documento.',
  start_tour: 'Inizia il tour',
  or_add_from: 'O aggiungi da',
  sync: 'Sincronizza',
  syncing: 'Sincronizzazione...',
  copy: 'Copia',
  paste: 'Incolla',
  select_fields: 'Seleziona Campi',
  draw_fields: 'Disegna Campi',
  align_left: 'Allinea a sinistra',
  align_right: 'Allinea a destra',
  align_top: 'Allinea in alto',
  align_bottom: 'Allinea in basso',
  fields_selected: '{count} Campi Selezionati',
  field_added: '{count} Campo Aggiunto',
  fields_added: '{count} Campi Aggiunti'
}

const pt = {
  fixed: 'Fixo',
  default: 'Padrão',
  save_as_custom_field: 'Salvar como personalizado',
  kba: 'KBA',
  autodetect_fields: 'Detectar campos',
  analyzing_: 'Analisando...',
  download: 'Baixar',
  downloading_: 'Baixando...',
  view: 'Visualizar',
  payment_link: 'Link de pagamento',
  strikeout: 'Tachado',
  draw_strikethrough_the_document: 'Desenhe uma linha de tachado no documento',
  quantity: 'Quantidade',
  prefillable: 'Pré-preenchível',
  signature_id: 'ID da Assinatura',
  error_message: 'Mensagem de erro',
  length: 'Comprimento',
  min: 'Mín',
  max: 'Máx',
  date_signed: 'Data atual',
  fonte: 'Fonte',
  party: 'Parte',
  method: 'Método',
  reorder_fields: 'Reorganizar campos',
  verify_id: 'Verificar ID',
  obtain_qualified_electronic_signature_with_the_trusted_provider_click_to_learn_more: 'Obtenha a assinatura eletrônica qualificada (QeS) com o provedor confiável. Clique para saber mais.',
  recurrent: 'Recurrente',
  one_off: 'Único',
  editable: 'Editável',
  search_field: 'Campo de busca',
  field_not_found: 'Campo não encontrado',
  clear: 'Limpar',
  type: 'Tipo',
  list: 'lista',
  no_variables: 'Ainda sem variáveis',
  no_variables_description: 'Adicione marcações [[variable]] ao documento para criar variáveis de conteúdo dinâmico.',
  type_value: 'Digite valor',
  add_all_required_fields_to_continue: 'Adicione todos os campos obrigatórios para continuar',
  uploaded_pdf_contains_form_fields_keep_or_remove_them: 'O PDF carregado contém campos. Manter ou removê-los?',
  keep: 'Manter',
  align: 'Alinhar',
  resize: 'Redimensionar',
  width: 'Largura',
  height: 'Altura',
  left: 'Esquerda',
  heading: 'Cabeçalho',
  validation: 'Validação',
  add_blank_page: 'Adicionar página em branco',
  right: 'Direita',
  center: 'Centro',
  with_logo: 'Com logotipo',
  description: 'Descrição',
  display_title: 'Título de exibição',
  signing_date: 'Data da Assinatura',
  unchecked: 'Não marcado',
  price: 'Preço',
  equal: 'Igual',
  not_equal: 'Não é igual',
  greater_than: 'Maior que',
  less_than: 'Menor que',
  contains: 'Contém',
  does_not_contain: 'Não contém',
  not_empty: 'Não vazio',
  empty: 'Vazio',
  add_condition: 'Adicionar condição',
  select_field_: 'Selecionar campo...',
  select_value_: 'Selecionar valor...',
  remove_condition: 'Remover condição',
  condition: 'Condição',
  make_dynamic: 'Tornar dinâmico',
  formula: 'Fórmula',
  edit: 'Editar',
  settings: 'Configurações',
  up: 'Para cima',
  down: 'Para baixo',
  set_signing_date: 'Definir data de assinatura',
  are_you_sure_: 'Tem certeza?',
  sign_yourself: 'Assine você mesmo',
  checked: 'Marcado',
  current_date: 'Data atual',
  send: 'Enviar',
  remove: 'Remover',
  save: 'Salvar',
  cancel: 'Cancelar',
  or_add_field_without_drawing: 'Ou adicione campo sem desenhar',
  draw_field_on_the_document: 'Desenhar um campo no documento',
  click_to_upload: 'Clique para enviar',
  or_drag_and_drop_files: 'ou arraste e solte arquivos',
  uploading: 'Carregando',
  processing_: 'Processando...',
  add_pdf_documents_or_images: 'Adicionar documentos PDF ou imagens',
  add_documents_or_images: 'Adicionar documentos ou imagens',
  add_a_new_document: 'Ajouter un nouveau document',
  replace_existing_document: 'Substituir documento existente',
  clone_and_replace_documents: 'Clonar e substituir documentos',
  required: 'Obrigatório',
  default_value: 'Valor padrão',
  format: 'Formato',
  read_only: 'Somente leitura',
  page: 'Página',
  draw_new_area: 'Desenhar nova área',
  copy_to_all_pages: 'Copiar para todas as páginas',
  more: 'Mais',
  add_option: 'Adicionar opção',
  option: 'Opção',
  options: 'Opções',
  first_party: 'Primeira Parte',
  second_party: 'Segunda Parte',
  third_party: 'Terceira Parte',
  fourth_party: 'Quarta Parte',
  fifth_party: 'Quinta Parte',
  sixth_party: 'Sexta Parte',
  seventh_party: 'Sétima Parte',
  eighth_party: 'Oitava Parte',
  ninth_party: 'Nona Parte',
  tenth_party: 'Décima Parte',
  eleventh_party: 'Décima Primeira Parte',
  twelfth_party: 'Décima Segunda Parte',
  thirteenth_party: 'Décima Terceira Parte',
  fourteenth_party: 'Décima Quarta Parte',
  fifteenth_party: 'Décima Quinta Parte',
  sixteenth_party: 'Décima Sexta Parte',
  seventeenth_party: 'Décima Sétima Parte',
  eighteenth_party: 'Décima Oitava Parte',
  nineteenth_party: 'Décima Nona Parte',
  twentieth_party: 'Vigésima Parte',
  draw: 'Desenhar',
  add: 'Adicionar',
  text: 'Texto',
  signature: 'Assinatura',
  initials: 'Rúbrica',
  date: 'Data',
  number: 'Número',
  image: 'Imagem',
  file: 'Arquivo',
  select: 'Selecionar',
  checkbox: 'Caixa',
  multiple: 'Múltiplo',
  radio: 'Rádio',
  cells: 'Células',
  stamp: 'Carimbo',
  payment: 'Pagamento',
  phone: 'Telefone',
  text_field: 'Campo de Texto',
  signature_field: 'Campo de Assinatura',
  initials_field: 'Campo de Rúbrica',
  date_field: 'Campo de Data',
  number_field: 'Campo de Número',
  image_field: 'Campo de Imagem',
  file_field: 'Campo de Arquivo',
  select_field: 'Campo de Seleção',
  checkbox_field: 'Campo de Caixa',
  multiple_field: 'Campo de Opção Múltipla',
  radio_field: 'Campo de Grupo Rádio',
  cells_field: 'Campo de Células',
  stamp_field: 'Campo de Carimbo',
  payment_field: 'Campo de Pagamento',
  phone_field: 'Campo de Telefone',
  draw_a_text_field_on_the_page_with_a_mouse: 'Desenhar um campo de texto na página com o mouse',
  drag_and_drop_any_other_field_type_on_the_page: 'Arraste e solte qualquer outro tipo de campo na página',
  click_on_the_field_type_above_to_start_drawing_it: 'Clique no tipo de campo acima para começar a desenhá-lo',
  please_draw_fields_to_prepare_the_document: 'Por favor, desenhe os campos para preparar o documento.',
  only_pdf_and_images_are_supported: 'Apenas PDFs e imagens são suportados.',
  unlock_sms_verified_phone_number_field_with_paid_plan_use_text_field_for_phone_numbers_without_verification: 'Desbloqueie o campo de número de telefone verificado por SMS com um plano pago. Use o campo de texto para números de telefone sem verificação.',
  available_only_in_pro: 'Disponível apenas no Pro',
  failed_to_download_files: 'Falha ao baixar arquivos',
  please_add_fields_for_the_submitter_name_or_remove_the_submitter_name_if_not_needed: 'Adicione campos para {submitter_name} ou remova {submitter_name} se não for necessário.',
  draw_field: 'Desenhar campo {field}',
  replace: 'Substituir',
  uploading_: 'Carregando...',
  add_document: 'Enviar',
  any: 'Qualquer',
  drawn: 'Desenhado',
  drawn_or_typed: 'Desenhado ou Digitado',
  drawn_or_upload: 'Desenhado ou Enviado',
  upload: 'Carregar',
  typed: 'Digitado',
  none: 'Nenhum',
  ssn: 'SSN',
  ein: 'EIN',
  email: 'Email',
  url: 'URL',
  zip: 'ZIP',
  custom: 'Personalizado',
  numbers_only: 'Somente números',
  letters_only: 'Somente letras',
  regexp_validation: 'Validação de expressão regular',
  custom_validation: 'Validação Personalizada',
  length_validation: 'Validação de Comprimento',
  number_range: 'Intervalo de Números',
  enter_pdf_password: 'Digite a senha do PDF',
  wrong_password: 'Senha incorreta',
  currency: 'Moeda',
  save_and_preview: 'Salvar e Pré-visualizar',
  preferences: 'Preferências',
  available_in_pro: 'Disponível no Pro',
  some_fields_are_missing_in_the_formula: 'Faltam alguns campos na fórmula.',
  learn_more: 'Saiba mais',
  and: 'e',
  or: 'ou',
  start_a_quick_tour_to_learn_how_to_create_an_send_your_first_document: 'Comece um tour rápido para aprender a criar e enviar seu primeiro documento.',
  start_tour: 'Iniciar tour',
  or_add_from: 'Ou adicionar de',
  sync: 'Sincronizar',
  syncing: 'Sincronizando...',
  copy: 'Copiar',
  paste: 'Colar',
  select_fields: 'Selecionar Campos',
  draw_fields: 'Desenhar Campos',
  align_left: 'Alinhar à esquerda',
  align_right: 'Alinhar à direita',
  align_top: 'Alinhar ao topo',
  align_bottom: 'Alinhar à parte inferior',
  fields_selected: '{count} Campos Selecionados',
  field_added: '{count} Campo Adicionado',
  fields_added: '{count} Campos Adicionados'
}

const fr = {
  fixed: 'Fixe',
  default: 'Par défaut',
  save_as_custom_field: 'Enregistrer comme personnalisé',
  kba: 'KBA',
  autodetect_fields: 'Détecter les champs',
  analyzing_: 'Analyse...',
  download: 'Télécharger',
  downloading_: 'Téléchargement...',
  view: 'Voir',
  payment_link: 'Lien de paiement',
  strikeout: 'Rature',
  draw_strikethrough_the_document: 'Tracer une rature sur le document',
  quantity: 'Quantité',
  prefillable: 'Préremplissable',
  signature_id: 'Identifiant de signature',
  error_message: "Message d'erreur",
  length: 'Longueur',
  min: 'Min',
  max: 'Max',
  font: 'Police',
  party: 'Partie',
  date_signed: 'Date de signature',
  method: 'Méthode',
  reorder_fields: 'Réorganiser les champs',
  verify_id: "Vérifier l'ID",
  obtain_qualified_electronic_signature_with_the_trusted_provider_click_to_learn_more: 'Obtenez une signature électronique qualifiée (QeS) auprès du fournisseur de confiance. Cliquez pour en savoir plus.',
  editable: 'Modifiable',
  recurrent: 'Récurrent',
  one_off: 'Ponctuel',
  search_field: 'Champ de recherche',
  field_not_found: 'Champ introuvable',
  clear: 'Effacer',
  align: 'Aligner',
  resize: 'Redimensionner',
  width: 'Largeur',
  height: 'Hauteur',
  add_all_required_fields_to_continue: 'Ajoutez tous les champs obligatoires pour continuer',
  uploaded_pdf_contains_form_fields_keep_or_remove_them: 'Le PDF téléversé contient des champs de formulaire. Les conserver ou les supprimer ?',
  keep: 'Conserver',
  left: 'Gauche',
  heading: 'Titre',
  validation: 'Validation',
  add_blank_page: 'Ajouter une page blanche',
  right: 'Droite',
  center: 'Centre',
  description: 'Description',
  display_title: 'Afficher le titre',
  with_logo: 'Avec logo',
  unchecked: 'Décoché',
  price: 'Prix',
  type: 'Type',
  list: 'liste',
  no_variables: 'Pas encore de variables',
  no_variables_description: 'Ajoutez des balises [[variable]] à votre document pour créer des variables de contenu dynamique.',
  type_value: 'Saisir une valeur',
  equal: 'Égal',
  not_equal: 'Différent',
  greater_than: 'Supérieur à',
  less_than: 'Inférieur à',
  contains: 'Contient',
  does_not_contain: 'Ne contient pas',
  not_empty: 'Non vide',
  empty: 'Vide',
  select_field_: 'Sélectionner un champ...',
  select_value_: 'Sélectionner une valeur...',
  remove_condition: 'Supprimer la condition',
  add_condition: 'Ajouter une condition',
  are_you_sure_: 'Êtes-vous sûr ?',
  sign_yourself: 'Signer vous-même',
  set_signing_date: 'Définir la date de signature',
  signing_date: 'Date de signature',
  send: 'Envoyer',
  remove: 'Supprimer',
  edit: 'Modifier',
  settings: 'Paramètres',
  up: 'Haut',
  down: 'Bas',
  checked: 'Coché',
  current_date: 'Date du jour',
  save: 'Enregistrer',
  cancel: 'Annuler',
  any: "N'importe lequel",
  drawn: 'Dessiné',
  drawn_or_typed: 'Dessiné ou tapé',
  drawn_or_upload: 'Dessiné ou téléversé',
  upload: 'Téléverser',
  formula: 'Formule',
  typed: 'Tapé',
  draw_field_on_the_document: 'Dessinez un champ sur le document',
  click_to_upload: 'Cliquez pour téléverser',
  or_drag_and_drop_files: 'ou faites glisser-déposer des fichiers',
  uploading: 'Téléversement en cours',
  processing_: 'Traitement...',
  add_pdf_documents_or_images: 'Ajouter des documents PDF ou des images',
  add_documents_or_images: 'Ajouter des documents ou des images',
  add_a_new_document: 'Ajouter un nouveau document',
  replace_existing_document: 'Remplacer le document existant',
  clone_and_replace_documents: 'Cloner et remplacer des documents',
  required: 'Obligatoire',
  default_value: 'Valeur par défaut',
  format: 'Format',
  read_only: 'Lecture seule',
  page: 'Page',
  draw_new_area: 'Dessiner une zone',
  copy_to_all_pages: 'Copier sur toutes les pages',
  more: 'Plus',
  add_option: 'Ajouter une option',
  option: 'Option',
  options: 'Options',
  condition: 'Condition',
  make_dynamic: 'Rendre dynamique',
  first_party: 'Première partie',
  second_party: 'Deuxième partie',
  third_party: 'Troisième partie',
  fourth_party: 'Quatrième partie',
  fifth_party: 'Cinquième partie',
  sixth_party: 'Sixième partie',
  seventh_party: 'Septième partie',
  eighth_party: 'Huitième partie',
  ninth_party: 'Neuvième partie',
  tenth_party: 'Dixième partie',
  eleventh_party: 'Onzième partie',
  twelfth_party: 'Douzième partie',
  thirteenth_party: 'Treizième partie',
  fourteenth_party: 'Quatorzième partie',
  fifteenth_party: 'Quinzième partie',
  sixteenth_party: 'Seizième partie',
  seventeenth_party: 'Dix-septième partie',
  eighteenth_party: 'Dix-huitième partie',
  nineteenth_party: 'Dix-neuvième partie',
  twentieth_party: 'Vingtième partie',
  draw: 'Dessiner',
  add: 'Ajouter',
  or_add_field_without_drawing: 'Ou ajouter un champ sans le dessiner',
  text: 'Texte',
  number: 'Nombre',
  signature: 'Signature',
  initials: 'Initiales',
  date: 'Date',
  image: 'Image',
  file: 'Fichier',
  select: 'Sélection',
  checkbox: 'Coche',
  multiple: 'Multiple',
  radio: 'Radio',
  cells: 'Cellules',
  stamp: 'Tampon',
  payment: 'Paiement',
  phone: 'Téléphone',
  text_field: 'Champ de texte',
  signature_field: 'Champ de signature',
  initials_field: "Champ d'initiales",
  date_field: 'Champ de date',
  number_field: 'Champ de numéro',
  image_field: "Champ d'image",
  file_field: 'Champ de fichier',
  select_field: 'Champ de choix',
  checkbox_field: 'Champ de coche',
  multiple_field: 'Champ de choix multiple',
  radio_field: 'Champ de groupe radio',
  cells_field: 'Champ de cellules',
  stamp_field: 'Champ de tampon',
  payment_field: 'Champ de paiement',
  phone_field: 'Champ de téléphone',
  draw_a_text_field_on_the_page_with_a_mouse: 'Dessinez un champ de texte sur la page avec la souris',
  drag_and_drop_any_other_field_type_on_the_page: 'Glissez-déposez tout autre type de champ sur la page',
  click_on_the_field_type_above_to_start_drawing_it: 'Cliquez sur le type de champ ci-dessus pour commencer à le dessiner',
  please_draw_fields_to_prepare_the_document: 'Veuillez dessiner des champs pour préparer le document.',
  only_pdf_and_images_are_supported: 'Seuls les PDF et les images sont pris en charge.',
  unlock_sms_verified_phone_number_field_with_paid_plan_use_text_field_for_phone_numbers_without_verification: 'Débloquez le champ de numéro de téléphone vérifié par SMS avec un forfait payant. Utilisez un champ texte pour les numéros sans vérification.',
  available_only_in_pro: 'Disponible uniquement dans la version Pro',
  failed_to_download_files: 'Impossible de télécharger les fichiers',
  please_add_fields_for_the_submitter_name_or_remove_the_submitter_name_if_not_needed: "Veuillez ajouter des champs pour {submitter_name}. Ou supprimez {submitter_name} si ce n'est pas nécessaire.",
  draw_field: 'Dessiner le champ {field}',
  replace: 'Remplacer',
  uploading_: 'Téléversement...',
  add_document: 'Téléverser',
  none: 'Aucun',
  ssn: 'SSN',
  ein: 'EIN',
  email: 'E-mail',
  url: 'URL',
  zip: 'ZIP',
  custom: 'Personnalisé',
  numbers_only: 'Chiffres uniquement',
  letters_only: 'Lettres uniquement',
  regexp_validation: 'Validation par expression régulière',
  custom_validation: 'Validation Personnalisée',
  length_validation: 'Validation de Longueur',
  number_range: 'Plage de Nombres',
  enter_pdf_password: 'Saisir le mot de passe du PDF',
  wrong_password: 'Mot de passe incorrect',
  currency: 'Devise',
  save_and_preview: 'Enregistrer et prévisualiser',
  preferences: 'Préférences',
  available_in_pro: 'Disponible dans la version Pro',
  some_fields_are_missing_in_the_formula: 'Certains champs manquent dans la formule.',
  learn_more: 'En savoir plus',
  and: 'et',
  or: 'ou',
  start_a_quick_tour_to_learn_how_to_create_an_send_your_first_document: 'Commencez une visite rapide pour apprendre à créer et à envoyer votre premier document',
  start_tour: 'Démarrer',
  or_add_from: 'Ou ajouter depuis',
  sync: 'Synchroniser',
  syncing: 'Synchronisation...',
  copy: 'Copier',
  paste: 'Coller',
  select_fields: 'Sélectionner Champs',
  draw_fields: 'Dessiner Champs',
  align_left: 'Aligner à gauche',
  align_right: 'Aligner à droite',
  align_top: 'Aligner en haut',
  align_bottom: 'Aligner en bas',
  fields_selected: '{count} Champs Sélectionnés',
  field_added: '{count} Champ Ajouté',
  fields_added: '{count} Champs Ajoutés'
}

const de = {
  fixed: 'Fest',
  default: 'Standard',
  save_as_custom_field: 'Als benutzerdefiniert speichern',
  kba: 'KBA',
  autodetect_fields: 'Felder erkennen',
  analyzing_: 'Analysiere...',
  download: 'Download',
  downloading_: 'Download...',
  view: 'Anzeigen',
  payment_link: 'Zahlungslink',
  strikeout: 'Durchstreichen',
  draw_strikethrough_the_document: 'Durchstreichung im Dokument zeichnen',
  quantity: 'Menge',
  prefillable: 'Vorausfüllbar',
  signature_id: 'Signatur-ID',
  error_message: 'Fehlermeldung',
  length: 'Länge',
  min: 'Min.',
  max: 'Max.',
  font: 'Schriftart',
  party: 'Partei',
  date_signed: 'Unterzeichnungsdatum',
  method: 'Methode',
  reorder_fields: 'Felder neu anordnen',
  verify_id: 'ID überprüfen',
  obtain_qualified_electronic_signature_with_the_trusted_provider_click_to_learn_more: 'Qualifizierte elektronische Signatur (QES) beim vertrauenswürdigen Anbieter einholen. Klicken Sie, um mehr zu erfahren.',
  editable: 'Bearbeitbar',
  recurrent: 'Wiederkehrend',
  one_off: 'Einmalig',
  search_field: 'Suchfeld',
  field_not_found: 'Feld nicht gefunden',
  clear: 'Leeren',
  align: 'Ausrichten',
  resize: 'Größe ändern',
  width: 'Breite',
  height: 'Höhe',
  add_all_required_fields_to_continue: 'Fügen Sie alle erforderlichen Felder hinzu, um fortzufahren',
  uploaded_pdf_contains_form_fields_keep_or_remove_them: 'Das hochgeladene PDF enthält Formularfelder. Beibehalten oder entfernen?',
  keep: 'Beibehalten',
  left: 'Links',
  heading: 'Überschrift',
  validation: 'Validierung',
  add_blank_page: 'Leere Seite hinzufügen',
  right: 'Rechts',
  center: 'Zentriert',
  description: 'Beschreibung',
  display_title: 'Anzeigetitel',
  with_logo: 'Mit Logo',
  unchecked: 'Nicht markiert',
  price: 'Preis',
  type: 'Typ',
  list: 'Liste',
  no_variables: 'Noch keine Variablen',
  no_variables_description: 'Fügen Sie [[variable]]-Markierungen zu Ihrem Dokument hinzu, um dynamische Inhaltsvariablen zu erstellen.',
  type_value: 'Wert eingeben',
  equal: 'Gleich',
  not_equal: 'Ungleich',
  greater_than: 'Größer als',
  less_than: 'Kleiner als',
  contains: 'Enthält',
  does_not_contain: 'Enthält nicht',
  not_empty: 'Nicht leer',
  empty: 'Leer',
  select_field_: 'Feld auswählen...',
  select_value_: 'Wert auswählen...',
  remove_condition: 'Bedingung entfernen',
  add_condition: 'Bedingung hinzufügen',
  are_you_sure_: 'Sind Sie sicher?',
  sign_yourself: 'Selbst unterschreiben',
  set_signing_date: 'Unterzeichnungsdatum festlegen',
  signing_date: 'Unterzeichnungsdatum',
  send: 'Senden',
  remove: 'Entfernen',
  edit: 'Bearbeiten',
  settings: 'Einstellungen',
  up: 'Nach oben',
  down: 'Nach unten',
  checked: 'Markiert',
  current_date: 'Aktuelles Datum',
  save: 'Speichern',
  cancel: 'Abbrechen',
  any: 'Beliebig',
  drawn: 'Gezeichnet',
  drawn_or_typed: 'Gezeichnet oder getippt',
  drawn_or_upload: 'Gezeichnet oder hochgeladen',
  upload: 'Hochladen',
  formula: 'Formel',
  typed: 'Getippt',
  draw_field_on_the_document: 'Ein Feld im Dokument zeichnen',
  click_to_upload: 'Zum Hochladen klicken',
  or_drag_and_drop_files: 'oder Dateien per Drag & Drop ablegen',
  uploading: 'Hochladen...',
  processing_: 'Verarbeiten...',
  add_pdf_documents_or_images: 'PDF-Dokumente oder Bilder hinzufügen',
  add_documents_or_images: 'Dokumente oder Bilder hinzufügen',
  add_a_new_document: 'Neues Dokument hinzufügen',
  replace_existing_document: 'Vorhandenes Dokument ersetzen',
  clone_and_replace_documents: 'Dokumente klonen und ersetzen',
  required: 'Erforderlich',
  default_value: 'Standardwert',
  format: 'Format',
  read_only: 'Nur lesen',
  page: 'Seite',
  draw_new_area: 'Bereich zeichnen',
  copy_to_all_pages: 'Auf alle Seiten kopieren',
  more: 'Mehr',
  add_option: 'Option hinzufügen',
  option: 'Option',
  options: 'Optionen',
  condition: 'Bedingung',
  make_dynamic: 'Dynamisch machen',
  first_party: 'Erste Partei',
  second_party: 'Zweite Partei',
  third_party: 'Dritte Partei',
  fourth_party: 'Vierte Partei',
  fifth_party: 'Fünfte Partei',
  sixth_party: 'Sechste Partei',
  seventh_party: 'Siebte Partei',
  eighth_party: 'Achte Partei',
  ninth_party: 'Neunte Partei',
  tenth_party: 'Zehnte Partei',
  eleventh_party: 'Elfte Partei',
  twelfth_party: 'Zwölfte Partei',
  thirteenth_party: 'Dreizehnte Partei',
  fourteenth_party: 'Vierzehnte Partei',
  fifteenth_party: 'Fünfzehnte Partei',
  sixteenth_party: 'Sechzehnte Partei',
  seventeenth_party: 'Siebzehnte Partei',
  eighteenth_party: 'Achtzehnte Partei',
  nineteenth_party: 'Neunzehnte Partei',
  twentieth_party: 'Zwanzigste Partei',
  draw: 'Zeichnen',
  add: 'Hinzufügen',
  or_add_field_without_drawing: 'Oder Feld ohne Zeichnen hinzufügen',
  text: 'Text',
  number: 'Zahl',
  signature: 'Unterschrift',
  initials: 'Initialen',
  date: 'Datum',
  image: 'Bild',
  file: 'Datei',
  select: 'Auswahl',
  checkbox: 'Checkbox',
  multiple: 'Mehrfach',
  radio: 'Radio',
  cells: 'Zellen',
  stamp: 'Stempel',
  payment: 'Zahlung',
  phone: 'Telefon',
  text_field: 'Textfeld',
  signature_field: 'Unterschriftsfeld',
  initials_field: 'Initialenfeld',
  date_field: 'Datumsfeld',
  number_field: 'Zahlenfeld',
  image_field: 'Bildfeld',
  file_field: 'Dateifeld',
  select_field: 'Auswahlfeld',
  checkbox_field: 'Checkboxfeld',
  multiple_field: 'Mehrfachauswahlfeld',
  radio_field: 'Radiogruppe',
  cells_field: 'Zellenfeld',
  stamp_field: 'Stempelfeld',
  payment_field: 'Zahlungsfeld',
  phone_field: 'Telefonfeld',
  draw_a_text_field_on_the_page_with_a_mouse: 'Ein Textfeld mit der Maus auf der Seite zeichnen',
  drag_and_drop_any_other_field_type_on_the_page: 'Jeden anderen Feldtyp auf die Seite ziehen und ablegen',
  click_on_the_field_type_above_to_start_drawing_it: 'Klicken Sie oben auf den Feldtyp, um mit dem Zeichnen zu beginnen',
  please_draw_fields_to_prepare_the_document: 'Bitte zeichnen Sie Felder, um das Dokument vorzubereiten.',
  only_pdf_and_images_are_supported: 'Nur PDF und Bilder werden unterstützt.',
  unlock_sms_verified_phone_number_field_with_paid_plan_use_text_field_for_phone_numbers_without_verification: 'SMS-verifiziertes Telefonnummernfeld mit kostenpflichtigem Plan freischalten. Verwenden Sie für Telefonnummern ohne Verifizierung das Textfeld.',
  available_only_in_pro: 'Nur in Pro verfügbar',
  failed_to_download_files: 'Dateien konnten nicht heruntergeladen werden',
  please_add_fields_for_the_submitter_name_or_remove_the_submitter_name_if_not_needed: 'Bitte fügen Sie Felder für {submitter_name} hinzu oder entfernen Sie {submitter_name}, falls nicht benötigt.',
  draw_field: '{field}-Feld zeichnen',
  replace: 'Ersetzen',
  uploading_: 'Hochladen...',
  add_document: 'Hochladen',
  none: 'Keine',
  ssn: 'SSN',
  ein: 'EIN',
  email: 'E-Mail',
  url: 'URL',
  zip: 'ZIP',
  custom: 'Benutzerdefiniert',
  numbers_only: 'Nur Zahlen',
  letters_only: 'Nur Buchstaben',
  regexp_validation: 'RegExp-Validierung',
  custom_validation: 'Benutzerdefinierte Validierung',
  length_validation: 'Längenvalidierung',
  number_range: 'Zahlenbereich',
  enter_pdf_password: 'PDF-Passwort eingeben',
  wrong_password: 'Falsches Passwort',
  currency: 'Währung',
  save_and_preview: 'Speichern und Vorschau',
  preferences: 'Voreinstellungen',
  available_in_pro: 'In Pro verfügbar',
  some_fields_are_missing_in_the_formula: 'Einige Felder fehlen in der Formel.',
  learn_more: 'Mehr erfahren',
  and: 'und',
  or: 'oder',
  start_a_quick_tour_to_learn_how_to_create_an_send_your_first_document: 'Starten Sie eine Kurztour, um zu lernen, wie Sie Ihr erstes Dokument erstellen und versenden.',
  start_tour: 'Tour starten',
  or_add_from: 'Oder hinzufügen aus',
  sync: 'Synchronisieren',
  syncing: 'Synchronisiere...',
  copy: 'Kopieren',
  paste: 'Einfügen',
  select_fields: 'Felder Auswählen',
  draw_fields: 'Felder Zeichnen',
  align_left: 'Links ausrichten',
  align_right: 'Rechts ausrichten',
  align_top: 'Oben ausrichten',
  align_bottom: 'Unten ausrichten',
  fields_selected: '{count} Felder Ausgewählt',
  field_added: '{count} Feld Hinzugefügt',
  fields_added: '{count} Felder Hinzugefügt'
}

const nl = {
  fixed: 'Vast',
  default: 'Standaard',
  save_as_custom_field: 'Opslaan als aangepast',
  kba: 'KBA',
  autodetect_fields: 'Velden detecteren',
  analyzing_: 'Analyseren...',
  download: 'Downloaden',
  downloading_: 'Downloaden...',
  view: 'Bekijken',
  payment_link: 'Betaallink',
  strikeout: 'Doorhalen',
  draw_strikethrough_the_document: 'Teken doorhaling in het document',
  quantity: 'Aantal',
  prefillable: 'Voorinvulbaar',
  signature_id: 'Handtekening-ID',
  error_message: 'Foutmelding',
  length: 'Lengte',
  min: 'Min',
  max: 'Max',
  font: 'Lettertype',
  party: 'Partij',
  date_signed: 'Datum ondertekend',
  method: 'Methode',
  reorder_fields: 'Velden herschikken',
  verify_id: 'ID verifiëren',
  obtain_qualified_electronic_signature_with_the_trusted_provider_click_to_learn_more: 'Verkrijg een gekwalificeerde elektronische handtekening (QeS) via de vertrouwde provider. Klik voor meer informatie.',
  editable: 'Bewerkbaar',
  recurrent: 'Terugkerend',
  one_off: 'Eenmalig',
  search_field: 'Zoekveld',
  field_not_found: 'Veld niet gevonden',
  clear: 'Wissen',
  align: 'Uitlijnen',
  resize: 'Formaat wijzigen',
  width: 'Breedte',
  height: 'Hoogte',
  add_all_required_fields_to_continue: 'Voeg alle vereiste velden toe om door te gaan',
  uploaded_pdf_contains_form_fields_keep_or_remove_them: 'Geüploade PDF bevat formuliervelden. Behouden of verwijderen?',
  keep: 'Behouden',
  left: 'Links',
  heading: 'Koptekst',
  validation: 'Validatie',
  add_blank_page: 'Lege pagina toevoegen',
  right: 'Rechts',
  center: 'Centreren',
  description: 'Beschrijving',
  display_title: 'Titel weergeven',
  with_logo: 'Met logo',
  unchecked: 'Niet aangevinkt',
  price: 'Prijs',
  type: 'Type',
  list: 'lijst',
  no_variables: 'Nog geen variabelen',
  no_variables_description: 'Voeg [[variable]]-markeringen toe aan uw document om dynamische inhoudsvariabelen te maken.',
  type_value: 'Typ waarde',
  equal: 'Gelijk aan',
  not_equal: 'Niet gelijk aan',
  greater_than: 'Groter dan',
  less_than: 'Kleiner dan',
  contains: 'Bevat',
  does_not_contain: 'Bevat niet',
  not_empty: 'Niet leeg',
  empty: 'Leeg',
  select_field_: 'Veld selecteren...',
  select_value_: 'Waarde selecteren...',
  remove_condition: 'Voorwaarde verwijderen',
  add_condition: 'Voorwaarde toevoegen',
  are_you_sure_: 'Weet u het zeker?',
  sign_yourself: 'Zelf ondertekenen',
  set_signing_date: 'Ondertekeningsdatum instellen',
  signing_date: 'Ondertekeningsdatum',
  send: 'Verzenden',
  remove: 'Verwijderen',
  edit: 'Bewerken',
  settings: 'Instellingen',
  up: 'Omhoog',
  down: 'Omlaag',
  checked: 'Aangevinkt',
  current_date: 'Huidige datum',
  save: 'Opslaan',
  cancel: 'Annuleren',
  any: 'Elke',
  drawn: 'Getekend',
  drawn_or_typed: 'Getekend of getypt',
  drawn_or_upload: 'Getekend of uploaden',
  upload: 'Uploaden',
  formula: 'Formule',
  typed: 'Getypt',
  draw_field_on_the_document: 'Teken een veld op het document',
  click_to_upload: 'Klik om te uploaden',
  or_drag_and_drop_files: 'of sleep bestanden hierheen',
  uploading: 'Uploaden',
  processing_: 'Bezig met verwerken...',
  add_pdf_documents_or_images: 'PDF-documenten of afbeeldingen toevoegen',
  add_documents_or_images: 'Documenten of afbeeldingen toevoegen',
  add_a_new_document: 'Nieuw document toevoegen',
  replace_existing_document: 'Bestaand document vervangen',
  clone_and_replace_documents: 'Documenten klonen en vervangen',
  required: 'Vereist',
  default_value: 'Standaardwaarde',
  format: 'Formaat',
  read_only: 'Alleen-lezen',
  page: 'Pagina',
  draw_new_area: 'Nieuw gebied tekenen',
  copy_to_all_pages: 'Kopieer naar alle pag.',
  more: 'Meer',
  add_option: 'Optie toevoegen',
  option: 'Optie',
  options: 'Opties',
  condition: 'Voorwaarde',
  make_dynamic: 'Dynamisch maken',
  first_party: 'Eerste partij',
  second_party: 'Tweede partij',
  third_party: 'Derde partij',
  fourth_party: 'Vierde partij',
  fifth_party: 'Vijfde partij',
  sixth_party: 'Zesde partij',
  seventh_party: 'Zevende partij',
  eighth_party: 'Achtste partij',
  ninth_party: 'Negende partij',
  tenth_party: 'Tiende partij',
  eleventh_party: 'Elfde partij',
  twelfth_party: 'Twaalfde partij',
  thirteenth_party: 'Dertiende partij',
  fourteenth_party: 'Veertiende partij',
  fifteenth_party: 'Vijftiende partij',
  sixteenth_party: 'Zestiende partij',
  seventeenth_party: 'Zeventiende partij',
  eighteenth_party: 'Achttiende partij',
  nineteenth_party: 'Negentiende partij',
  twentieth_party: 'Twintigste partij',
  draw: 'Tekenen',
  add: 'Toevoegen',
  or_add_field_without_drawing: 'Of voeg een veld toe zonder te tekenen',
  text: 'Tekst',
  number: 'Getal',
  signature: 'Signatuur',
  initials: 'Initialen',
  date: 'Datum',
  image: 'Afbeelding',
  file: 'Bestand',
  select: 'Selecteren',
  checkbox: 'Checkbox',
  multiple: 'Meerdere',
  radio: 'Radio',
  cells: 'Cellen',
  stamp: 'Stempel',
  payment: 'Betaling',
  phone: 'Telefoon',
  text_field: 'Tekstveld',
  signature_field: 'Signatuurveld',
  initials_field: 'Initialenveld',
  date_field: 'Datumveld',
  number_field: 'Getalveld',
  image_field: 'Afbeeldingsveld',
  file_field: 'Bestandsveld',
  select_field: 'Selectieveld',
  checkbox_field: 'Aankruisvakje',
  multiple_field: 'Meerkeuzeveld',
  radio_field: 'Radiogroepveld',
  cells_field: 'Cellenveld',
  stamp_field: 'Stempelveld',
  payment_field: 'Betalingsveld',
  phone_field: 'Telefoonveld',
  draw_a_text_field_on_the_page_with_a_mouse: 'Teken met de muis een tekstveld op de pagina',
  drag_and_drop_any_other_field_type_on_the_page: 'Sleep elk ander veldtype naar de pagina',
  click_on_the_field_type_above_to_start_drawing_it: 'Klik op het bovenstaande veldtype om te beginnen met tekenen',
  please_draw_fields_to_prepare_the_document: 'Teken velden om het document voor te bereiden.',
  only_pdf_and_images_are_supported: 'Alleen PDF en afbeeldingen worden ondersteund.',
  unlock_sms_verified_phone_number_field_with_paid_plan_use_text_field_for_phone_numbers_without_verification: 'Ontgrendel het SMS-geverifieerde veld voor telefoonnummer met een betaald abonnement. Gebruik het tekstveld voor telefoonnummers zonder verificatie.',
  available_only_in_pro: 'Alleen beschikbaar in Pro',
  failed_to_download_files: 'Bestanden downloaden mislukt',
  please_add_fields_for_the_submitter_name_or_remove_the_submitter_name_if_not_needed: 'Voeg velden toe voor de {submitter_name}. Of verwijder de {submitter_name} als deze niet nodig is.',
  draw_field: 'Teken het veld {field}',
  replace: 'Vervangen',
  uploading_: 'Bezig met uploaden...',
  add_document: 'Doc. toevoegen',
  none: 'Geen',
  ssn: 'SSN',
  ein: 'EIN',
  email: 'E-mail',
  url: 'URL',
  zip: 'Postcode',
  custom: 'Aangepast',
  numbers_only: 'Alleen cijfers',
  letters_only: 'Alleen letters',
  regexp_validation: 'Regex validatie',
  custom_validation: 'Aangepaste Validatie',
  length_validation: 'Lengte Validatie',
  number_range: 'Getalbereik',
  enter_pdf_password: 'Voer PDF-wachtwoord in',
  wrong_password: 'Onjuist wachtwoord',
  currency: 'Valuta',
  save_and_preview: 'Opslaan & bekijken',
  preferences: 'Voorkeuren',
  available_in_pro: 'Beschikbaar in Pro',
  some_fields_are_missing_in_the_formula: 'Sommige velden ontbreken in de formule.',
  learn_more: 'Meer informatie',
  and: 'en',
  or: 'of',
  start_a_quick_tour_to_learn_how_to_create_an_send_your_first_document: 'Start een korte rondleiding om te leren hoe u uw eerste document maakt en verzendt',
  start_tour: 'Rondleiding starten',
  or_add_from: 'Of toevoegen van',
  sync: 'Synchroniseren',
  syncing: 'Synchroniseren...',
  copy: 'Kopiëren',
  paste: 'Plakken',
  select_fields: 'Velden Selecteren',
  draw_fields: 'Velden Tekenen',
  align_left: 'Links uitlijnen',
  align_right: 'Rechts uitlijnen',
  align_top: 'Boven uitlijnen',
  align_bottom: 'Onder uitlijnen',
  fields_selected: '{count} Velden Geselecteerd',
  field_added: '{count} Veld Toegevoegd',
  fields_added: '{count} Velden Toegevoegd'
}

const ko = {
  fixed: '고정',
  default: '기본값',
  save_as_custom_field: '사용자 지정 필드로 저장',
  kba: 'KBA',
  analyzing_: '분석 중...',
  download: '다운로드',
  downloading_: '다운로드 중...',
  view: '보기',
  autodetect_fields: '필드 자동 감지',
  payment_link: '결제 링크',
  strikeout: '취소선',
  draw_strikethrough_the_document: '문서에 취소선 그리기',
  quantity: '수량',
  prefillable: '사전 입력 가능',
  signature_id: '서명 ID',
  error_message: '오류 메시지',
  length: '길이',
  min: '최소',
  max: '최대',
  font: '글꼴',
  party: '당사자',
  date_signed: '서명일',
  method: '방법',
  reorder_fields: '필드 순서 변경',
  verify_id: '신원 확인',
  obtain_qualified_electronic_signature_with_the_trusted_provider_click_to_learn_more: '신뢰할 수 있는 제공업체를 통해 적격 전자서명(QeS)을 발급받으세요. 자세히 알아보려면 클릭하세요.',
  editable: '편집 가능',
  recurrent: '반복',
  one_off: '1회성',
  search_field: '필드 검색',
  field_not_found: '필드를 찾을 수 없습니다',
  clear: '지우기',
  align: '정렬',
  resize: '크기 조정',
  width: '너비',
  height: '높이',
  add_all_required_fields_to_continue: '계속하려면 필수 필드를 모두 추가하세요',
  uploaded_pdf_contains_form_fields_keep_or_remove_them: '업로드한 PDF에 양식 필드가 포함되어 있습니다. 유지하시겠습니까, 제거하시겠습니까?',
  keep: '유지',
  left: '왼쪽',
  heading: '제목',
  validation: '유효성 검사',
  add_blank_page: '빈 페이지 추가',
  right: '오른쪽',
  center: '가운데',
  description: '설명',
  display_title: '표시 제목',
  with_logo: '로고 포함',
  unchecked: '선택 안 함',
  price: '가격',
  type: '유형',
  list: '목록',
  no_variables: '아직 변수가 없습니다',
  no_variables_description: '문서에 [[variable]] 표시를 추가하여 동적 콘텐츠 변수를 만드세요.',
  type_value: '값 입력',
  equal: '같음',
  not_equal: '같지 않음',
  greater_than: '보다 큼',
  less_than: '보다 작음',
  contains: '포함',
  does_not_contain: '포함하지 않음',
  not_empty: '비어 있지 않음',
  empty: '비어 있음',
  select_field_: '필드 선택...',
  select_value_: '값 선택...',
  remove_condition: '조건 제거',
  add_condition: '조건 추가',
  are_you_sure_: '계속하시겠습니까?',
  sign_yourself: '직접 서명',
  set_signing_date: '서명일 설정',
  signing_date: '서명 날짜',
  send: '보내기',
  remove: '제거',
  edit: '편집',
  settings: '설정',
  up: '위로',
  down: '아래로',
  checked: '선택함',
  current_date: '현재 날짜',
  save: '저장',
  cancel: '취소',
  any: '모두',
  drawn: '그리기',
  drawn_or_typed: '그리기 또는 입력',
  drawn_or_upload: '그리기 또는 업로드',
  upload: '업로드',
  formula: '수식',
  typed: '입력',
  draw_field_on_the_document: '문서에 필드 그리기',
  click_to_upload: '클릭하여 업로드',
  or_drag_and_drop_files: '또는 파일을 끌어다 놓으세요',
  uploading: '업로드 중',
  processing_: '처리 중...',
  add_pdf_documents_or_images: 'PDF 문서 또는 이미지 추가',
  add_documents_or_images: '문서 또는 이미지 추가',
  add_a_new_document: '새 문서 추가',
  replace_existing_document: '기존 문서 교체',
  clone_and_replace_documents: '문서 복제 후 교체',
  required: '필수',
  default_value: '기본값',
  format: '형식',
  read_only: '읽기 전용',
  page: '페이지',
  draw_new_area: '새 영역 그리기',
  copy_to_all_pages: '모든 페이지에 복사',
  more: '더 보기',
  add_option: '옵션 추가',
  option: '옵션',
  options: '옵션',
  condition: '조건',
  make_dynamic: '동적으로 설정',
  first_party: '첫 번째 당사자',
  second_party: '두 번째 당사자',
  third_party: '세 번째 당사자',
  fourth_party: '네 번째 당사자',
  fifth_party: '다섯 번째 당사자',
  sixth_party: '여섯 번째 당사자',
  seventh_party: '일곱 번째 당사자',
  eighth_party: '여덟 번째 당사자',
  ninth_party: '아홉 번째 당사자',
  tenth_party: '열 번째 당사자',
  eleventh_party: '열한 번째 당사자',
  twelfth_party: '열두 번째 당사자',
  thirteenth_party: '열세 번째 당사자',
  fourteenth_party: '열네 번째 당사자',
  fifteenth_party: '열다섯 번째 당사자',
  sixteenth_party: '열여섯 번째 당사자',
  seventeenth_party: '열일곱 번째 당사자',
  eighteenth_party: '열여덟 번째 당사자',
  nineteenth_party: '열아홉 번째 당사자',
  twentieth_party: '스무 번째 당사자',
  draw: '그리기',
  add: '추가',
  or_add_field_without_drawing: '또는 그리지 않고 필드 추가',
  text: '텍스트',
  number: '숫자',
  signature: '서명',
  initials: '이니셜',
  date: '날짜',
  image: '이미지',
  file: '파일',
  select: '선택',
  checkbox: '체크박스',
  multiple: '다중 선택',
  radio: '라디오',
  cells: '셀',
  stamp: '도장',
  payment: '결제',
  phone: '전화번호',
  text_field: '텍스트 필드',
  signature_field: '서명 필드',
  initials_field: '이니셜 필드',
  date_field: '날짜 필드',
  number_field: '숫자 필드',
  image_field: '이미지 필드',
  file_field: '파일 필드',
  select_field: '선택 필드',
  checkbox_field: '체크박스 필드',
  multiple_field: '다중 선택 필드',
  radio_field: '라디오 그룹 필드',
  cells_field: '셀 필드',
  stamp_field: '도장 필드',
  payment_field: '결제 필드',
  phone_field: '전화번호 필드',
  draw_a_text_field_on_the_page_with_a_mouse: '마우스로 페이지에 텍스트 필드 그리기',
  drag_and_drop_any_other_field_type_on_the_page: '페이지에 다른 필드 유형을 끌어다 놓으세요',
  click_on_the_field_type_above_to_start_drawing_it: '위의 필드 유형을 클릭하여 그리기를 시작하세요',
  please_draw_fields_to_prepare_the_document: '문서를 준비하려면 필드를 그려주세요.',
  only_pdf_and_images_are_supported: 'PDF와 이미지만 지원됩니다.',
  unlock_sms_verified_phone_number_field_with_paid_plan_use_text_field_for_phone_numbers_without_verification: '유료 플랜에서 SMS 인증 전화번호 필드를 이용할 수 있습니다. 인증이 필요 없는 전화번호에는 텍스트 필드를 사용하세요.',
  available_only_in_pro: 'Pro 플랜에서만 사용 가능',
  failed_to_download_files: '파일 다운로드에 실패했습니다',
  please_add_fields_for_the_submitter_name_or_remove_the_submitter_name_if_not_needed: '{submitter_name}에 필드를 추가해주세요. 필요하지 않다면 {submitter_name}을(를) 제거하세요.',
  draw_field: '{field} 필드 그리기',
  replace: '교체',
  uploading_: '업로드 중...',
  add_document: '문서 추가',
  none: '없음',
  ssn: 'SSN',
  ein: 'EIN',
  email: '이메일',
  url: 'URL',
  zip: '우편번호',
  custom: '사용자 지정',
  numbers_only: '숫자만',
  letters_only: '문자만',
  regexp_validation: '정규식 검증',
  custom_validation: '사용자 지정 검증',
  length_validation: '길이 검증',
  number_range: '숫자 범위',
  enter_pdf_password: 'PDF 비밀번호 입력',
  wrong_password: '잘못된 비밀번호',
  currency: '통화',
  save_and_preview: '저장 후 미리보기',
  preferences: '환경설정',
  available_in_pro: 'Pro 플랜에서 사용 가능',
  some_fields_are_missing_in_the_formula: '수식에 일부 필드가 누락되었습니다.',
  learn_more: '자세히 알아보기',
  and: '그리고',
  or: '또는',
  start_a_quick_tour_to_learn_how_to_create_an_send_your_first_document: '빠른 투어를 시작하여 첫 문서를 만들고 보내는 방법을 알아보세요',
  start_tour: '투어 시작',
  or_add_from: '또는 다음에서 추가',
  sync: '동기화',
  syncing: '동기화 중...',
  copy: '복사',
  paste: '붙여넣기',
  select_fields: '필드 선택',
  draw_fields: '필드 그리기',
  align_left: '왼쪽 정렬',
  align_right: '오른쪽 정렬',
  align_top: '위쪽 정렬',
  align_bottom: '아래쪽 정렬',
  fields_selected: '필드 {count}개 선택됨',
  field_added: '필드 {count}개 추가됨',
  fields_added: '필드 {count}개 추가됨',
}

const ja = {
  fixed: '固定',
  default: 'デフォルト',
  save_as_custom_field: 'カスタムフィールドとして保存',
  kba: 'KBA',
  analyzing_: '解析中...',
  download: 'ダウンロード',
  downloading_: 'ダウンロード中...',
  view: '表示',
  autodetect_fields: 'フィールドを自動検出',
  payment_link: '支払いリンク',
  strikeout: '取り消し線',
  draw_strikethrough_the_document: '書類に取り消し線を描く',
  quantity: '数量',
  prefillable: '事前入力可能',
  signature_id: '署名ID',
  error_message: 'エラーメッセージ',
  length: '長さ',
  min: '最小',
  max: '最大',
  font: 'フォント',
  party: '当事者',
  date_signed: '署名日',
  method: '方法',
  reorder_fields: 'フィールドの並べ替え',
  verify_id: '本人確認',
  obtain_qualified_electronic_signature_with_the_trusted_provider_click_to_learn_more: '信頼できるプロバイダーで適格電子署名（QeS）を取得します。クリックして詳細をご覧ください。',
  editable: '編集可能',
  recurrent: '定期',
  one_off: '一回限り',
  search_field: 'フィールドを検索',
  field_not_found: 'フィールドが見つかりません',
  clear: 'クリア',
  align: '整列',
  resize: 'サイズ変更',
  width: '幅',
  height: '高さ',
  add_all_required_fields_to_continue: '続行するには必須フィールドをすべて追加してください',
  uploaded_pdf_contains_form_fields_keep_or_remove_them: 'アップロードしたPDFにはフォームフィールドが含まれています。保持しますか、削除しますか？',
  keep: '保持',
  left: '左',
  heading: '見出し',
  validation: '検証',
  add_blank_page: '空白ページを追加',
  right: '右',
  center: '中央',
  description: '説明',
  display_title: '表示タイトル',
  with_logo: 'ロゴ付き',
  unchecked: '未チェック',
  price: '価格',
  type: '種類',
  list: 'リスト',
  no_variables: '変数はまだありません',
  no_variables_description: '書類に [[variable]] マークを追加すると、動的なコンテンツ変数を作成できます。',
  type_value: '値を入力',
  equal: '等しい',
  not_equal: '等しくない',
  greater_than: 'より大きい',
  less_than: 'より小さい',
  contains: '含む',
  does_not_contain: '含まない',
  not_empty: '空でない',
  empty: '空',
  select_field_: 'フィールドを選択...',
  select_value_: '値を選択...',
  remove_condition: '条件を削除',
  add_condition: '条件を追加',
  are_you_sure_: 'よろしいですか？',
  sign_yourself: '自分で署名',
  set_signing_date: '署名日を設定',
  signing_date: '署名日',
  send: '送信',
  remove: '削除',
  edit: '編集',
  settings: '設定',
  up: '上',
  down: '下',
  checked: 'チェック済み',
  current_date: '現在の日付',
  save: '保存',
  cancel: 'キャンセル',
  any: '任意',
  drawn: '手書き',
  drawn_or_typed: '手書きまたは入力',
  drawn_or_upload: '手書きまたはアップロード',
  upload: 'アップロード',
  formula: '数式',
  typed: '入力',
  draw_field_on_the_document: '書類にフィールドを描画',
  click_to_upload: 'クリックしてアップロード',
  or_drag_and_drop_files: 'またはファイルをドラッグ＆ドロップ',
  uploading: 'アップロード中',
  processing_: '処理中...',
  add_pdf_documents_or_images: 'PDF書類または画像を追加',
  add_documents_or_images: '書類または画像を追加',
  add_a_new_document: '新しい書類を追加',
  replace_existing_document: '既存の書類を置き換え',
  clone_and_replace_documents: '書類を複製して置き換え',
  required: '必須',
  default_value: 'デフォルト値',
  format: '形式',
  read_only: '読み取り専用',
  page: 'ページ',
  draw_new_area: '新しい領域を描画',
  copy_to_all_pages: 'すべてのページにコピー',
  more: 'その他',
  add_option: '選択肢を追加',
  option: '選択肢',
  options: '選択肢',
  condition: '条件',
  make_dynamic: '動的にする',
  first_party: '第一当事者',
  second_party: '第二当事者',
  third_party: '第三当事者',
  fourth_party: '第四当事者',
  fifth_party: '第五当事者',
  sixth_party: '第六当事者',
  seventh_party: '第七当事者',
  eighth_party: '第八当事者',
  ninth_party: '第九当事者',
  tenth_party: '第十当事者',
  eleventh_party: '第十一当事者',
  twelfth_party: '第十二当事者',
  thirteenth_party: '第十三当事者',
  fourteenth_party: '第十四当事者',
  fifteenth_party: '第十五当事者',
  sixteenth_party: '第十六当事者',
  seventeenth_party: '第十七当事者',
  eighteenth_party: '第十八当事者',
  nineteenth_party: '第十九当事者',
  twentieth_party: '第二十当事者',
  draw: '描画',
  add: '追加',
  or_add_field_without_drawing: 'または描画せずにフィールドを追加',
  text: 'テキスト',
  number: '数値',
  signature: '署名',
  initials: 'イニシャル',
  date: '日付',
  image: '画像',
  file: 'ファイル',
  select: '選択',
  checkbox: 'チェックボックス',
  multiple: '複数選択',
  radio: 'ラジオボタン',
  cells: 'セル',
  stamp: '印鑑',
  payment: '支払い',
  phone: '電話番号',
  text_field: 'テキストフィールド',
  signature_field: '署名フィールド',
  initials_field: 'イニシャルフィールド',
  date_field: '日付フィールド',
  number_field: '数値フィールド',
  image_field: '画像フィールド',
  file_field: 'ファイルフィールド',
  select_field: '選択フィールド',
  checkbox_field: 'チェックボックスフィールド',
  multiple_field: '複数選択フィールド',
  radio_field: 'ラジオグループフィールド',
  cells_field: 'セルフィールド',
  stamp_field: '印鑑フィールド',
  payment_field: '支払いフィールド',
  phone_field: '電話番号フィールド',
  draw_a_text_field_on_the_page_with_a_mouse: 'マウスでページにテキストフィールドを描画',
  drag_and_drop_any_other_field_type_on_the_page: 'その他のフィールドタイプはページにドラッグ＆ドロップ',
  click_on_the_field_type_above_to_start_drawing_it: '上のフィールドタイプをクリックすると描画を開始できます',
  please_draw_fields_to_prepare_the_document: 'フィールドを描画して書類を準備してください。',
  only_pdf_and_images_are_supported: 'PDFと画像のみサポートされています。',
  unlock_sms_verified_phone_number_field_with_paid_plan_use_text_field_for_phone_numbers_without_verification: '有料プランでSMS認証済み電話番号フィールドを利用できます。認証なしの電話番号にはテキストフィールドをご利用ください。',
  available_only_in_pro: 'Proプランでのみ利用可能',
  failed_to_download_files: 'ファイルのダウンロードに失敗しました',
  please_add_fields_for_the_submitter_name_or_remove_the_submitter_name_if_not_needed: '{submitter_name} のフィールドを追加してください。不要な場合は {submitter_name} を削除してください。',
  draw_field: '{field} フィールドを描画',
  replace: '置き換え',
  uploading_: 'アップロード中...',
  add_document: '書類を追加',
  none: 'なし',
  ssn: 'SSN',
  ein: 'EIN',
  email: 'メール',
  url: 'URL',
  zip: '郵便番号',
  custom: 'カスタム',
  numbers_only: '数字のみ',
  letters_only: '文字のみ',
  regexp_validation: '正規表現検証',
  custom_validation: 'カスタム検証',
  length_validation: '長さの検証',
  number_range: '数値の範囲',
  enter_pdf_password: 'PDFのパスワードを入力',
  wrong_password: 'パスワードが正しくありません',
  currency: '通貨',
  save_and_preview: '保存してプレビュー',
  preferences: '環境設定',
  available_in_pro: 'Proプランで利用可能',
  some_fields_are_missing_in_the_formula: '数式に一部のフィールドがありません。',
  learn_more: '詳細を見る',
  and: 'かつ',
  or: 'または',
  start_a_quick_tour_to_learn_how_to_create_an_send_your_first_document: 'クイックツアーを開始して、最初の書類の作成と送信方法を学びましょう',
  start_tour: 'ツアーを開始',
  or_add_from: 'または次から追加',
  sync: '同期',
  syncing: '同期中...',
  copy: 'コピー',
  paste: '貼り付け',
  select_fields: 'フィールドを選択',
  draw_fields: 'フィールドを描画',
  align_left: '左揃え',
  align_right: '右揃え',
  align_top: '上揃え',
  align_bottom: '下揃え',
  fields_selected: '{count} 件のフィールドを選択中',
  field_added: '{count} 件のフィールドを追加しました',
  fields_added: '{count} 件のフィールドを追加しました',
}

const zhCN = {
  fixed: '固定',
  default: '默认',
  save_as_custom_field: '另存为自定义字段',
  kba: 'KBA',
  analyzing_: '正在分析…',
  download: '下载',
  downloading_: '正在下载…',
  view: '查看',
  autodetect_fields: '自动检测字段',
  payment_link: '支付链接',
  strikeout: '删除线',
  draw_strikethrough_the_document: '在文档上绘制删除线',
  quantity: '数量',
  prefillable: '可预填',
  signature_id: '签名ID',
  error_message: '错误消息',
  length: '长度',
  min: '最小值',
  max: '最大值',
  font: '字体',
  party: '签署方',
  date_signed: '签署日期',
  method: '方式',
  reorder_fields: '重新排序字段',
  verify_id: '验证身份',
  obtain_qualified_electronic_signature_with_the_trusted_provider_click_to_learn_more: '通过受信任的服务商获取合格电子签名(QES)。点击了解更多。',
  editable: '可编辑',
  recurrent: '循环',
  one_off: '一次性',
  search_field: '搜索字段',
  field_not_found: '未找到字段',
  clear: '清除',
  align: '对齐',
  resize: '调整大小',
  width: '宽度',
  height: '高度',
  add_all_required_fields_to_continue: '添加所有必填字段以继续',
  uploaded_pdf_contains_form_fields_keep_or_remove_them: '上传的PDF包含表单字段。保留还是移除?',
  keep: '保留',
  left: '左',
  heading: '标题',
  validation: '验证',
  add_blank_page: '添加空白页',
  right: '右',
  center: '居中',
  description: '描述',
  display_title: '显示标题',
  with_logo: '带徽标',
  unchecked: '未选中',
  price: '价格',
  type: '类型',
  list: '列表',
  no_variables: '暂无变量',
  no_variables_description: '在文档中添加 [[变量]] 标记以创建动态内容变量。',
  type_value: '输入值',
  equal: '等于',
  not_equal: '不等于',
  greater_than: '大于',
  less_than: '小于',
  contains: '包含',
  does_not_contain: '不包含',
  not_empty: '非空',
  empty: '空',
  select_field_: '选择字段…',
  select_value_: '选择值…',
  remove_condition: '移除条件',
  add_condition: '添加条件',
  are_you_sure_: '您确定吗?',
  sign_yourself: '自行签署',
  set_signing_date: '设置签署日期',
  signing_date: '签署日期',
  send: '发送',
  remove: '移除',
  edit: '编辑',
  settings: '设置',
  up: '上移',
  down: '下移',
  checked: '已选中',
  current_date: '当前日期',
  save: '保存',
  cancel: '取消',
  any: '任意',
  drawn: '手绘',
  drawn_or_typed: '手绘或输入',
  drawn_or_upload: '手绘或上传',
  upload: '上传',
  formula: '公式',
  typed: '输入',
  draw_field_on_the_document: '在文档上绘制字段',
  click_to_upload: '点击上传',
  or_drag_and_drop_files: '或拖放文件',
  uploading: '正在上传',
  processing_: '正在处理…',
  add_pdf_documents_or_images: '添加PDF文档或图片',
  add_documents_or_images: '添加文档或图片',
  add_a_new_document: '添加新文档',
  replace_existing_document: '替换现有文档',
  clone_and_replace_documents: '克隆并替换文档',
  required: '必填',
  default_value: '默认值',
  format: '格式',
  read_only: '只读',
  page: '页面',
  draw_new_area: '绘制新区域',
  copy_to_all_pages: '复制到所有页面',
  more: '更多',
  add_option: '添加选项',
  option: '选项',
  options: '选项',
  condition: '条件',
  make_dynamic: '设为动态',
  first_party: '第一方',
  second_party: '第二方',
  third_party: '第三方',
  fourth_party: '第四方',
  fifth_party: '第五方',
  sixth_party: '第六方',
  seventh_party: '第七方',
  eighth_party: '第八方',
  ninth_party: '第九方',
  tenth_party: '第十方',
  eleventh_party: '第十一方',
  twelfth_party: '第十二方',
  thirteenth_party: '第十三方',
  fourteenth_party: '第十四方',
  fifteenth_party: '第十五方',
  sixteenth_party: '第十六方',
  seventeenth_party: '第十七方',
  eighteenth_party: '第十八方',
  nineteenth_party: '第十九方',
  twentieth_party: '第二十方',
  draw: '绘制',
  add: '添加',
  or_add_field_without_drawing: '或不绘制直接添加字段',
  text: '文本',
  number: '数字',
  signature: '签名',
  initials: '签名缩写',
  date: '日期',
  image: '图片',
  file: '文件',
  select: '下拉选择',
  checkbox: '复选框',
  multiple: '多选',
  radio: '单选',
  cells: '单元格',
  stamp: '印章',
  payment: '支付',
  phone: '电话',
  text_field: '文本字段',
  signature_field: '签名字段',
  initials_field: '签名缩写字段',
  date_field: '日期字段',
  number_field: '数字字段',
  image_field: '图片字段',
  file_field: '文件字段',
  select_field: '下拉选择字段',
  checkbox_field: '复选框字段',
  multiple_field: '多选字段',
  radio_field: '单选组字段',
  cells_field: '单元格字段',
  stamp_field: '印章字段',
  payment_field: '支付字段',
  phone_field: '电话字段',
  draw_a_text_field_on_the_page_with_a_mouse: '用鼠标在页面上绘制文本字段',
  drag_and_drop_any_other_field_type_on_the_page: '将其他任意字段类型拖放到页面上',
  click_on_the_field_type_above_to_start_drawing_it: '点击上方的字段类型开始绘制',
  please_draw_fields_to_prepare_the_document: '请绘制字段以准备文档。',
  only_pdf_and_images_are_supported: '仅支持PDF和图片。',
  unlock_sms_verified_phone_number_field_with_paid_plan_use_text_field_for_phone_numbers_without_verification: '升级付费方案以解锁短信验证的电话号码字段。如无需验证,请使用文本字段填写电话号码。',
  available_only_in_pro: '仅在专业版中可用',
  failed_to_download_files: '文件下载失败',
  please_add_fields_for_the_submitter_name_or_remove_the_submitter_name_if_not_needed: '请为{submitter_name}添加字段。如不需要,请移除{submitter_name}。',
  draw_field: '绘制{field}字段',
  replace: '替换',
  uploading_: '正在上传…',
  add_document: '添加文档',
  none: '无',
  ssn: 'SSN',
  ein: 'EIN',
  email: '邮箱',
  url: 'URL',
  zip: '邮政编码',
  custom: '自定义',
  numbers_only: '仅限数字',
  letters_only: '仅限字母',
  regexp_validation: '正则表达式验证',
  custom_validation: '自定义验证',
  length_validation: '长度验证',
  number_range: '数字范围',
  enter_pdf_password: '输入PDF密码',
  wrong_password: '密码错误',
  currency: '货币',
  save_and_preview: '保存并预览',
  preferences: '偏好设置',
  available_in_pro: '专业版可用',
  some_fields_are_missing_in_the_formula: '公式中缺少部分字段。',
  learn_more: '了解更多',
  and: '且',
  or: '或',
  start_a_quick_tour_to_learn_how_to_create_an_send_your_first_document: '开始快速导览,了解如何创建并发送您的第一份文档',
  start_tour: '开始导览',
  or_add_from: '或从以下位置添加',
  sync: '同步',
  syncing: '正在同步…',
  copy: '复制',
  paste: '粘贴',
  select_fields: '选择字段',
  draw_fields: '绘制字段',
  align_left: '左对齐',
  align_right: '右对齐',
  align_top: '顶端对齐',
  align_bottom: '底端对齐',
  fields_selected: '已选择{count}个字段',
  field_added: '已添加{count}个字段',
  fields_added: '已添加{count}个字段',
}

const zhTW = {
  fixed: '固定',
  default: '預設',
  save_as_custom_field: '另存為自訂欄位',
  kba: 'KBA',
  analyzing_: '分析中…',
  download: '下載',
  downloading_: '下載中…',
  view: '檢視',
  autodetect_fields: '自動偵測欄位',
  payment_link: '付款連結',
  strikeout: '刪除線',
  draw_strikethrough_the_document: '在文件上繪製刪除線',
  quantity: '數量',
  prefillable: '可預填',
  signature_id: '簽名 ID',
  error_message: '錯誤訊息',
  length: '長度',
  min: '最小值',
  max: '最大值',
  font: '字型',
  party: '簽署方',
  date_signed: '簽署日期',
  method: '方式',
  reorder_fields: '重新排序欄位',
  verify_id: '驗證身分',
  obtain_qualified_electronic_signature_with_the_trusted_provider_click_to_learn_more: '透過受信任的服務商取得合格電子簽名(QES)。點擊以了解更多。',
  editable: '可編輯',
  recurrent: '重複',
  one_off: '一次性',
  search_field: '搜尋欄位',
  field_not_found: '找不到欄位',
  clear: '清除',
  align: '對齊',
  resize: '調整大小',
  width: '寬度',
  height: '高度',
  add_all_required_fields_to_continue: '請新增所有必填欄位以繼續',
  uploaded_pdf_contains_form_fields_keep_or_remove_them: '上傳的 PDF 包含表單欄位。要保留還是移除?',
  keep: '保留',
  left: '靠左',
  heading: '標題',
  validation: '驗證',
  add_blank_page: '新增空白頁',
  right: '靠右',
  center: '置中',
  description: '說明',
  display_title: '顯示標題',
  with_logo: '含標誌',
  unchecked: '未勾選',
  price: '價格',
  type: '類型',
  list: '清單',
  no_variables: '尚無變數',
  no_variables_description: '在文件中新增 [[變數]] 標記以建立動態內容變數。',
  type_value: '輸入值',
  equal: '等於',
  not_equal: '不等於',
  greater_than: '大於',
  less_than: '小於',
  contains: '包含',
  does_not_contain: '不包含',
  not_empty: '非空白',
  empty: '空白',
  select_field_: '選擇欄位…',
  select_value_: '選擇值…',
  remove_condition: '移除條件',
  add_condition: '新增條件',
  are_you_sure_: '您確定嗎?',
  sign_yourself: '自行簽署',
  set_signing_date: '設定簽署日期',
  signing_date: '簽署日期',
  send: '傳送',
  remove: '移除',
  edit: '編輯',
  settings: '設定',
  up: '上移',
  down: '下移',
  checked: '已勾選',
  current_date: '目前日期',
  save: '儲存',
  cancel: '取消',
  any: '任何',
  drawn: '手繪',
  drawn_or_typed: '手繪或輸入',
  drawn_or_upload: '手繪或上傳',
  upload: '上傳',
  formula: '公式',
  typed: '輸入',
  draw_field_on_the_document: '在文件上繪製欄位',
  click_to_upload: '點擊上傳',
  or_drag_and_drop_files: '或拖放檔案',
  uploading: '上傳中',
  processing_: '處理中…',
  add_pdf_documents_or_images: '新增 PDF 文件或圖片',
  add_documents_or_images: '新增文件或圖片',
  add_a_new_document: '新增文件',
  replace_existing_document: '取代現有文件',
  clone_and_replace_documents: '複製並取代文件',
  required: '必填',
  default_value: '預設值',
  format: '格式',
  read_only: '唯讀',
  page: '頁面',
  draw_new_area: '繪製新區域',
  copy_to_all_pages: '複製到所有頁面',
  more: '更多',
  add_option: '新增選項',
  option: '選項',
  options: '選項',
  condition: '條件',
  make_dynamic: '設為動態',
  first_party: '第一方',
  second_party: '第二方',
  third_party: '第三方',
  fourth_party: '第四方',
  fifth_party: '第五方',
  sixth_party: '第六方',
  seventh_party: '第七方',
  eighth_party: '第八方',
  ninth_party: '第九方',
  tenth_party: '第十方',
  eleventh_party: '第十一方',
  twelfth_party: '第十二方',
  thirteenth_party: '第十三方',
  fourteenth_party: '第十四方',
  fifteenth_party: '第十五方',
  sixteenth_party: '第十六方',
  seventeenth_party: '第十七方',
  eighteenth_party: '第十八方',
  nineteenth_party: '第十九方',
  twentieth_party: '第二十方',
  draw: '繪製',
  add: '新增',
  or_add_field_without_drawing: '或不繪製直接新增欄位',
  text: '文字',
  number: '數字',
  signature: '簽名',
  initials: '簽名縮寫',
  date: '日期',
  image: '圖片',
  file: '檔案',
  select: '下拉選擇',
  checkbox: '核取方塊',
  multiple: '多選',
  radio: '單選',
  cells: '儲存格',
  stamp: '印章',
  payment: '付款',
  phone: '電話',
  text_field: '文字欄位',
  signature_field: '簽名欄位',
  initials_field: '簽名縮寫欄位',
  date_field: '日期欄位',
  number_field: '數字欄位',
  image_field: '圖片欄位',
  file_field: '檔案欄位',
  select_field: '下拉選擇欄位',
  checkbox_field: '核取方塊欄位',
  multiple_field: '多選欄位',
  radio_field: '單選群組欄位',
  cells_field: '儲存格欄位',
  stamp_field: '印章欄位',
  payment_field: '付款欄位',
  phone_field: '電話欄位',
  draw_a_text_field_on_the_page_with_a_mouse: '用滑鼠在頁面上繪製文字欄位',
  drag_and_drop_any_other_field_type_on_the_page: '將其他任何欄位類型拖放到頁面上',
  click_on_the_field_type_above_to_start_drawing_it: '點擊上方的欄位類型開始繪製',
  please_draw_fields_to_prepare_the_document: '請繪製欄位以準備文件。',
  only_pdf_and_images_are_supported: '僅支援 PDF 和圖片。',
  unlock_sms_verified_phone_number_field_with_paid_plan_use_text_field_for_phone_numbers_without_verification: '升級付費方案以解鎖簡訊驗證的電話號碼欄位。若不需要驗證,請使用文字欄位填寫電話號碼。',
  available_only_in_pro: '僅限專業版使用',
  failed_to_download_files: '檔案下載失敗',
  please_add_fields_for_the_submitter_name_or_remove_the_submitter_name_if_not_needed: '請為 {submitter_name} 新增欄位。如不需要,請移除 {submitter_name}。',
  draw_field: '繪製{field}欄位',
  replace: '取代',
  uploading_: '上傳中…',
  add_document: '新增文件',
  none: '無',
  ssn: 'SSN',
  ein: 'EIN',
  email: '電子郵件',
  url: 'URL',
  zip: '郵遞區號',
  custom: '自訂',
  numbers_only: '僅限數字',
  letters_only: '僅限字母',
  regexp_validation: '正規表示式驗證',
  custom_validation: '自訂驗證',
  length_validation: '長度驗證',
  number_range: '數字範圍',
  enter_pdf_password: '輸入 PDF 密碼',
  wrong_password: '密碼錯誤',
  currency: '貨幣',
  save_and_preview: '儲存並預覽',
  preferences: '偏好設定',
  available_in_pro: '專業版可用',
  some_fields_are_missing_in_the_formula: '公式中缺少部分欄位。',
  learn_more: '了解更多',
  and: '且',
  or: '或',
  start_a_quick_tour_to_learn_how_to_create_an_send_your_first_document: '開始快速導覽,了解如何建立並傳送您的第一份文件',
  start_tour: '開始導覽',
  or_add_from: '或從以下位置新增',
  sync: '同步',
  syncing: '同步中…',
  copy: '複製',
  paste: '貼上',
  select_fields: '選擇欄位',
  draw_fields: '繪製欄位',
  align_left: '靠左對齊',
  align_right: '靠右對齊',
  align_top: '靠上對齊',
  align_bottom: '靠下對齊',
  fields_selected: '已選擇 {count} 個欄位',
  field_added: '已新增 {count} 個欄位',
  fields_added: '已新增 {count} 個欄位',
}

export { en, es, it, pt, fr, de, nl, ko, ja, zhCN as 'zh-cn', zhTW as 'zh-tw' }
